/* istanbul ignore file */
import CreateHealthcheckForm from 'domain/people/employee/Timeline/healthcheck/form/CreateHealthcheckForm';
import EmployeeHealthcheckTimelineRecordLayout from 'domain/people/employee/Timeline/healthcheck/shared/layout/EmployeeHealthcheckTimelineRecordLayout';
import { TimelineRegistry, TimelineItem } from 'domain/people/employee/Timeline/types';

const useEmployeeHealthcheckItem = (): TimelineRegistry => ({
  AddForm: CreateHealthcheckForm,
  UpdateForm: null,
  isApplicable: (item: TimelineItem) => !!item.note,
  RecordLayout: EmployeeHealthcheckTimelineRecordLayout,
  source: 'note',
  urlPostfix: '',
  name: 'Healthcheck',
});

export default useEmployeeHealthcheckItem;
